export default {
  title: {
    en: '{count}-Month Plan',
  },
  totalPrice: {
    en: '<span>Total:</span> {value}',
  },
  scentPrice: {
    en: 'Just {value} / product',
  },
}
